import { useEffect } from "react";
import { initBiff } from "@/lib/AdManagment/biffUtils";
import { waitForCookieConsent } from "@/lib/AdManagment/biffUtils";

interface UseBiffInitializationProps {
  hasBannerGPT: boolean;
  isLoggedIn: boolean;
  isProduction: boolean;
}

export const useBiffInitialization = ({
  hasBannerGPT,
  isLoggedIn,
  isProduction,
}: UseBiffInitializationProps) => {
  useEffect(() => {
    if (!hasBannerGPT || !isProduction) return;

    const initializeGlobalBiff = async () => {
      // Prevent multiple initializations
      if (window.globalBiffInitialized) {
        return;
      }

      try {
        const consentResult = await waitForCookieConsent();

        if (!consentResult.shouldInitializeBiff) {
          // skip initialization if consent is not obtained
          return;
        }

        await initBiff(isProduction, isLoggedIn);

        // Mark as globally initialized
        window.globalBiffInitialized = true;
      } catch (error) {
        console.error("Global BIFF initialization failed:", error);
        // Reset flag on error to allow retry
        window.globalBiffInitialized = false;
      }
    };

    initializeGlobalBiff();
  }, [hasBannerGPT, isLoggedIn, isProduction]);
};

export default useBiffInitialization;
